/*
 *   File : footer.js
 *   Author : https://evoqins.com
 *   Description : Footer component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React from 'react';

const Footer = (props) => {
    return (
        <div className={`${props.type !== 2 && "position-absolute bottom-0 w-100"}`}>
            <div className={`e-bg-transparent px-4 padding-40px-bottom `}>
                <div className='container mx-0'>
                    <div className='d-flex align-items-start justify-content-space-between'>
                        <p className='mb-0 e-font-12 line-height-22px e-text-primary-blue e-font-weight-600 e-primary-font'>
                            {new Date().getFullYear()} © Z Remit All Rights Reserved 
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer;